export function CheckoutStepper({ payment }: { payment: boolean }) {
  return (
    <ol className="marker-checkout-stepper" aria-label="Checkout steps">
      <li aria-current={payment ? undefined : "step"}>
        <span>1</span> Plan
      </li>
      <li className="marker-checkout-connector" aria-hidden="true" />
      <li aria-current={payment ? "step" : undefined}>
        <span>2</span> Payment
      </li>
    </ol>
  );
}
